import { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

export default function usePdfDocument(fileUrl) {
	const [pdf, setPdf] = useState(null);
	const [numPages, setNumPages] = useState(0);
	const [docLoading, setDocLoading] = useState(false);
	const firstPageSizeRef = useRef(null);

	useEffect(() => {
		pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
	}, []);

	useEffect(() => {
		if (!fileUrl) return;
		let canceled = false;

		(async () => {
			try {
				setDocLoading(true);
				const loadingTask = pdfjsLib.getDocument({
					url: fileUrl,
					disableStream: false,
					disableAutoFetch: false,
					rangeChunkSize: 1 << 18,
					stopAtErrors: true
				});
				const doc = await loadingTask.promise;
				if (canceled) return;

				const first = await doc.getPage(1);
				const vp = first.getViewport({ scale: 1 });
				firstPageSizeRef.current = { width: vp.width, height: vp.height };

				// Set pdf and numPages AFTER firstPageSizeRef is ready
				setPdf(doc);
				setNumPages(doc.numPages);
			} catch {
				// swallow errors or add error state if you want
			} finally {
				if (!canceled) setDocLoading(false);
			}
		})();

		return () => {
			canceled = true;
		};
	}, [fileUrl]);

	return { pdf, numPages, docLoading, firstPageSizeRef };
}
